import { render, staticRenderFns } from "./Scene24.vue?vue&type=template&id=58deef72&scoped=true"
import script from "./Scene24.vue?vue&type=script&lang=js"
export * from "./Scene24.vue?vue&type=script&lang=js"
import style0 from "./Scene24.vue?vue&type=style&index=0&id=58deef72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58deef72",
  null
  
)

export default component.exports